<template>
  <el-dialog
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    class="new_dialog"
    width="1125px"
    title="拓词工具"
    append-to-body
  >
    <div class="container">
      <el-form
        class="form"
        ref="formRef"
        :model="formData"
        :rules="rules"
        hide-required-asterisk
        @submit.stop.prevent="submitForm(formRef)"
      >
        <el-form-item prop="keytxt">
          <div class="input">
            <el-input
              v-model="formData.keytxt"
              placeholder="请输入关键词"
              type="search"
            />
            <el-button
              class="submit"
              type="primary"
              @click="submitForm(formRef)"
              :loading="reactiveData.loading"
              :disabled="reactiveData.disable_time > 0"
            >
              {{
                reactiveData.disable_time > 0
                  ? reactiveData.disable_time
                  : '搜索'
              }}
            </el-button>
            <el-button @click="exportHandle">导出</el-button>
          </div>
        </el-form-item>
      </el-form>
      <TableList :data="reactiveData.data" v-loading="reactiveData.loading" />
    </div>
  </el-dialog>
</template>

<script setup>
import { toRefs, ref, reactive } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { yunutoolsokey } from '@/utils/api'
import TableList from './PopupTool3TableList.vue'
import { postExcelFile } from '@/utils'

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const formRef = ref()

const rules = reactive({
  keytxt: [{ required: true, message: '请输入关键词' }],
})

const reactiveData = reactive({
  loading: false,
  disable_time: 0,
  timer: null,
  data: [],
})

const formData = reactive({
  keytxt: '',
})

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      try {
        reactiveData.loading = true
        reactiveData.disable_time = 5
        clearInterval(reactiveData.timer)
        reactiveData.timer = setInterval(() => {
          reactiveData.disable_time--
          if (reactiveData.disable_time <= 0) {
            clearInterval(reactiveData.timer)
          }
        }, 1000)
        // const { data: res } = await axios.post(
        //   'http://cha.i-huoke.com/index.php/Api/toolsokey.html',
        //   formData
        // )
        const { data: res } = await yunutoolsokey(formData)

        reactiveData.data = res.data
        reactiveData.loading = false
      } catch (error) {
        console.log(error)
        ElMessage.error(error.message)
        reactiveData.loading = false
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}

const exportHandle = () => {
  postExcelFile(
    { ...formData, export: 1 },
    `${process.env.VUE_APP_baseURL}/Api/yunutoolsokey`
  )
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 5%;
  .form {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    --el-borde: 0;
    /* min-height: 40%; */
    transition: all 0.3s;
    --el-font-size-base: 16px;
    .title {
      font-weight: bold;
      letter-spacing: 4px;
      color: #fff;
      margin-bottom: 30px;
      font-size: 24px;
    }
    .input {
      display: flex;
      min-width: 661px;
      .el-button {
        border-radius: 0;
      }
      .submit {
        border: 0;
      }
      .el-input__wrapper {
        box-shadow: none;
        border-radius: 0;
      }
    }
    .el-form-item__error {
      color: #f00;
      margin-top: 5px;
    }
  }
}
</style>
